import { useRef, useCallback } from "react";
import { useScreenshot } from "../api";

/**
 * Hook that provides screenshot capture functionality.
 * Returns a ref to wrap the target element and a function to trigger the capture.
 */
export default function useCaptureScreenshot(financialInstitutionId: string) {
  const screenshotHelper = useScreenshot(financialInstitutionId);
  const screenshotAreaRef = useRef<HTMLDivElement>(null);

  const captureScreenshot = useCallback(
    async (applicationId: string, slug: string) => {
      // Disable animations via direct DOM manipulation (no re-render)
      if (screenshotAreaRef.current) {
        screenshotAreaRef.current.style.setProperty(
          "animation",
          "none",
          "important"
        );
        screenshotAreaRef.current.style.setProperty(
          "transition",
          "none",
          "important"
        );
        const allElements = screenshotAreaRef.current.querySelectorAll("*");
        allElements.forEach((el) => {
          (el as HTMLElement).style.setProperty(
            "animation",
            "none",
            "important"
          );
          (el as HTMLElement).style.setProperty(
            "transition",
            "none",
            "important"
          );
        });
      }

      await screenshotHelper.capture(applicationId, screenshotAreaRef, slug);
    },
    [screenshotHelper]
  );

  return { screenshotAreaRef, captureScreenshot };
}
